import Text14 from '@sdk/components/ui/typography/Text14';
import gettext from '@sdk/lang/gettext';
import Row from '@sdk/components/ui/spacing/Row';
import formatTime from '@sdk/utils/dateFormat/formatTime';
import TranslateWithComponents from '@sdk/lang/TranslateWithComponents';
import { ThemeColorType } from '@sdk/theme/ThemeColorType';
import type { TimesheetHistoryTimeEntry } from '@sdk/timesheets/types/TimesheetHistory';
import useAuth from '@sdk/authentication/useAuth';

type Props = {
  editedChange: TimesheetHistoryTimeEntry;
};

const TimesheetHistoryRowsForClockOutEdit = ({ editedChange }: Props) => {
  const { currentUser } = useAuth();

  return (
    <>
      <Text14 themeColor={ThemeColorType.gray} mTop={5}>
        {gettext('Edited clock out time')}
      </Text14>
      <Row>
        <Text14 themeColor={ThemeColorType.gray}>
          <TranslateWithComponents
            replaceComponents={{
              fromTime: (
                <Text14 themeColor={ThemeColorType.danger}>
                  {formatTime(editedChange.clockOutFrom, currentUser.settings.usTimeFormat)}
                </Text14>
              ),
              toTime: (
                <Text14 themeColor={ThemeColorType.success}>
                  {formatTime(editedChange.clockOutTo, currentUser.settings.usTimeFormat)}
                </Text14>
              ),
            }}>
            {gettext('From [[fromTime]] to [[toTime]]')}
          </TranslateWithComponents>
        </Text14>
      </Row>
    </>
  );
};

export default TimesheetHistoryRowsForClockOutEdit;
